<div class="container-fluid">
    <div class="row">

        <div class="col-md-4 col-offset-2 mt-4">

            <form class="example-form" [formGroup]="registerForm" *ngFor="let folder of userData?.projLists">
                <mat-card class="registerForm">
                    <mat-card-header>
                        <mat-card-title>
                            Edit Client
                        </mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div>
                            <mat-form-field class="example-full-width col-md-12">
                                <input matInput [(ngModel)]="folder.name" placeholder="Client name"
                                    formControlName="client">
                            </mat-form-field>
                            <mat-form-field class="example-full-width col-md-12">
                                <input matInput placeholder="Proffesion" [(ngModel)]="folder.profession"
                                    formControlName="prof">
                            </mat-form-field>
                            
                            <mat-form-field class="example-full-width col-md-12">
                                <input matInput placeholder="Email" [(ngModel)]="folder.emailid"
                                    formControlName="emailid">
                            </mat-form-field>
                            <div class="text-danger col-md-12"
                                *ngIf="registerForm.controls.emailid.invalid && registerForm.controls.emailid.touched">
                                Email not valid
                            </div>

                            <mat-form-field class="example-full-width col-md-12">


                                <input type="password" #input matInput placeholder="Password" [(ngModel)]="folder.pass"
                                    formControlName="pass">

                                <mat-icon (click)="showPassword(input)" class="passicon">{{sign}}</mat-icon>


                            </mat-form-field>



                            <div class="text-danger col-md-12"
                                *ngIf="registerForm.controls.pass.invalid && registerForm.controls.pass.touched">
                                Please enter password
                            </div>
                            <mat-form-field class="example-full-width col-md-12">
                                <input type="number" matInput placeholder="Phone number" formControlName="mobile"
                                    [(ngModel)]="folder.mobile">
                            </mat-form-field>
                            <div class="text-danger col-md-12"
                                *ngIf="registerForm.controls.mobile.invalid && registerForm.controls.mobile.touched">
                                Please enter Valid Phone number
                            </div>

                        </div>


                    </mat-card-content>
                    <mat-card-actions>
                        <div class="register">
                            <button [routerLink]="['/mrfd']" class="back mr-4" type="button" mat-raised-button
                                color="primary">BACK</button>
                            <button id="edit" (click)="editClientDetails()" type="button" mat-raised-button
                                color="primary">Edit Client Details</button>

                        </div>
                    </mat-card-actions>
                </mat-card>

            </form>
        </div>
        <div class="col-md-6">

            <img class="regAdeosImg" src="assets/images/buildchart.png" />

        </div>
    </div>
</div>